<template>
  <div class="handleVerbalTrick">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="110px"
        >
          <el-form-item label="话术分类" prop="name">
            <el-input
              v-model="formInline.name"
              maxlength="80"
              style="width: 300px"
              placeholder="请输入话术分类"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序号" prop="sortNum">
            <el-input
              v-model="formInline.sortNum"
              maxlength="5"
              style="width: 300px"
              @input="sortNumInput"
              placeholder="请输入排序号"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addSpeechcraftClassify,
  updateSpeechcraftClassify,
} from "@/api/marketingAdmin/technicalDialogue.js";
export default {
  data() {
    return {
      dialogTitle: "",
      dialogVisible: false,
      formInline: {
        name: "",
        sortNum: "",
      },
      rules: {
        name: [{ required: true, message: "请输入话术分类", trigger: "blur" }],
        sortNum: [{ required: true, message: "请输入排序号", trigger: "blur" }],
      },
      status: "",
    };
  },
  methods: {
    sortNumInput(payload) {
      this.$nextTick(() => {
        this.$set(this.formInline, "sortNum", payload.replace(/[^\d]/g, ""));
      });
    },
    // 初始化
    init(status, payload) {
      Object.assign(this.$data, this.$options.data());
      this.status = status;
      this.dialogTitle = status === "add" ? "新建话术分类" : "编辑话术分类";
      if (status === "alter") {
        Object.keys(this.formInline).forEach((item) => {
          this.formInline[item] = payload[item];
        });
        this.formInline.id = payload.id;
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          if (this.status === "add") {
            addSpeechcraftClassify({ ...this.formInline }).then((res) => {
              if (res.code === 0) {
                this.$emit("refresh");
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          } else if (this.status === "alter") {
            updateSpeechcraftClassify({ ...this.formInline }).then((res) => {
              if (res.code === 0) {
                this.$emit("refresh");
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          }
        }
      });
    },
  },
};
</script>